import React from 'react';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close_2.svg';
import icInfo from 'assets/svg/ic_info_blue.svg';
import Modal from 'src/Components/Modal';
import Button from 'src/Pages/Staking/Components/Button';
import ErrorMessage from '../../Components/ErrorMessage';

const ConfirmModal = ({
  onClose,
  onUnstake
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    src: icCloseIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Thank you for staking"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "By staking, you have significantly contributed to capture the value of THG token and empower Thetan Arena to achieve our vision.", /*#__PURE__*/React.createElement("br", null), "Sincerely, thank you!"), /*#__PURE__*/React.createElement(ErrorMessage, {
    className: styles.warning,
    message: "Partial unstake is unvailable"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Unstake",
    type: "secondary",
    onClick: onUnstake
  }), /*#__PURE__*/React.createElement(Button, {
    title: "Close",
    type: "primary",
    onClick: onClose
  }))));
};

export default ConfirmModal;